import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import { useState } from "react";
import CodeIcon from "@mui/icons-material/Code";


import moment from "moment";
import { GlobalState } from "../../../context/GlobalContext";
import FileSaver from "file-saver";
import DisplayDataGrid from "components/ReusableComponents/DisplayDataGrid";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";

const Grn = () => {
    const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
    const [result, setResult] = useState([]);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    const handleGetGrn = async (e,action) => {
        e.preventDefault();
        try {
                let params = {
                    startDate,
                    endDate,
                    action
                };
                setLoadingOpen(true);
                await pythonVmInstance({
                    url: `/uc_vs_ginesys/grn`,
                    params: params,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    method: "GET",
                    responseType: action =="get" ? "json" : "blob",
                }).then((res) => {
                    const data = res?.data?.result;
                    console.log("pythonVmInstance",res?.data?.result)
                    
                    if (action != "get") {
                        setResult([]);
                        const url = URL.createObjectURL(res.data);
                        FileSaver.saveAs(url, `${startDate}_${endDate}_grn_uc_vs_ginesys.csv`);
                        setLoadingOpen(false);
                    }else{
                        setResult(data);
                        setLoadingOpen(false);
                    }
                });
            } catch (error) {
                setSnackBarOpen(true);
                setLoadingOpen(false);
                setSnackBar({
                    ...snackBar,
                    message: "Failed to download file",
                    severity: "error",
                    anchorOrigin: { horizontal: "center", vertical: "top" },
                });
            }
        };
    console.log(result, "result")
    return (
        <Stack spacing={2} component="form" onSubmit={(e) => handleGetGrn(e,"get")}>
			<Typography variant="h6">Compare GRN</Typography>
			{/* form */}
			<Box display="flex" columnGap={2}>
				<Stack spacing={1}>
					<InputLabel>Select Start Date</InputLabel>
					<TextField
						size="small"
						type="date"
						value={startDate}
						onChange={(e) => setStartDate(e.target.value)}
						required
						placeholder="compliance certificate issue date"
					/>
				</Stack>
				<Stack spacing={1}>
					<InputLabel>Select End Date</InputLabel>
					<TextField
						size="small"
						type="date"
						value={endDate}
						onChange={(e) => setEndDate(e.target.value)}
						required
						placeholder="compliance certificate issue date"
					/>
				</Stack>
			</Box>
			<Button
				variant="contained"
				sx={{ width: "200px" }}
				type="submit"
				startIcon={<CodeIcon />}>
					Run Query
			</Button>
		 {result.length ? (
				// table
				<Box sx={{ width: "100%" }} pb={5}>
					<Typography variant="h6">Result</Typography>
					<Box display="flex" pt={2} pb={2}>
						<Typography p="10px  5px" pr={2}>
							Raise To Ginesys From {moment(startDate).format("DD-MM-YYYY")} to{" "}
							{moment(endDate).format("DD-MM-YYYY")}
						</Typography>
						<Button
							onClick={(e) => handleGetGrn(e,"download")}
							sx={{ textTransform: "capitalize" }}
							variant="contained">
							Download
						</Button>
					</Box>
					 {result.length ? (
						<DisplayDataGrid
							rows={result}
							columns={Object.keys(result[0])}
						/>
					) : (
						<Typography color="red" variant="subtitle1">
							No records to display
						</Typography>
					)}
				 </Box> 
			 ) : ( 
				<></>
		 )}
		</Stack>
    );
};

export default Grn;